import { NgModule }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { FormsModule }        from '@angular/forms';

import { JwtModule } from '@auth0/angular-jwt';
import { LoginComponent } from './login.component';
import { AngularMaterialModule } from '../angular-material.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule
  ],
  declarations: [
    LoginComponent
  ],
  exports:      [ LoginComponent ],
  providers:    [ ]
})

export class LoginModule { }
